<template>
  <div class="kw_calendar">
    <div class="calendar calendar-style">
      <!--主标题-->
      <div class="calendar-header header-style" v-if="(header)">
          <span v-if="(year == min_year && month == min_month)"></span>
          <span class="cwj-icon cwj-calendar-icon-left" @click="prevMonth" v-else-if="(prev)"></span>
          <span v-else></span>
          <el-date-picker v-model="year_month" type="month" placeholder="选择月" @change="dateChange" format="yyyy-MM" value-format="yyyy-MM" :clearable="false"></el-date-picker>
          
          <span v-if="(year == max_year && month == max_month)"></span>
          <span class="cwj-icon cwj-calendar-icon-right" @click="nextMonth" v-else-if="(next)"></span>
          <span v-else></span>
      </div>

      <!--日历面板-->
      <div class="calendar-board board-style">
          <!--周标题-->
          <div class="calendar-weeks" v-if="(weeks && weekTitle.length == 7)">
              <span class="calendar-weekday" v-for="(item,index) in weekTitle" :key="'week_'+index">{{item}}</span>
          </div>

          <!--日期-->
          <div class="calendar-days">
              <!--日期行-->
              <div class="calendar-row" v-for="(item,i) in days_array" :key="'rq_'+i">
                  <div v-for="(day,index) in days_array[i]" :key="'rqh_'+index">
                      <div class="calendar-cell" :style="'background: '+(day.background)+'; width: '+(cellSize)+'px; height: '+(cellSize)+'px;'" v-if="(day.day <= 0)"></div>
                      <div class="calendar-cell positionLocation" :style="'background: '+(day.background)+'; width: '+(cellSize)+'px; height: '+(cellSize)+'px;'" v-else-if="(activeType == 'square')" @click="dayClick" :data-day="(day)">
                        <span v-if="(day.numMark>0)" class="curriculumNumber">{{day.numMark}}</span>
                          <span v-if="(day.info == 'prev')">
                              <span class="calendar-day" style="'color: '+(day.color)+';'">{{day.day}}</span>
                              <span v-if="(addon == 'lunar')&&(lunar)" class="calendar-lunar-day" :style="'color: '+(day.color)+';'">{{day.lunarDay}}</span>
                              <span v-else-if="(addon == 'custom')" class="calendar-lunar-day" :style="'color: '+(day.color)+';'">{{days_addon[c]}}</span>
                              <span v-else-if="(addon == 'mixed')">
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-if="(days_addon[i] != '')">{{days_addon[i]}}</span>
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-else>{{day.lunarDay}}</span>
                              </span>
                          </span>
                          <span v-else-if="(day.info == 'next')">
                              <span class="calendar-day" :style="'color: '+(day.color)+';'">{{day.day}}</span>
                              <span v-if="(lunar)&&(addon == 'lunar')" class="calendar-lunar-day" :style="'color: '+(day.color)+';'">{{day.lunarDay}}</span>
                              <span v-else-if="(addon == 'custom')" class="calendar-lunar-day" :style="'color: '+(day.color)+';'">{{days_addon[i]}}</span>
                              <span v-else-if="(addon == 'mixed')">
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-if="(days_addon[i] != '')">{{days_addon[i]}}</span>
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-else>{{day.lunarDay}}</span>
                              </span>
                          </span>
                          <span v-else>
                              <span class="calendar-day" :style="'color: '+(day.color)+';'">{{day.day}}</span>
                              <span v-if="(lunar)&&(addon == 'lunar')" class="calendar-lunar-day" :style="'color: '+(day.color)+';'" >{{day.lunarDay}}</span>
                              <span v-else-if="(addon == 'custom')" class="calendar-lunar-day" :style="'color: '+(day.color)+';'">{{days_addon[i]}}</span>
                              <span v-else-if="(addon == 'mixed')">
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-if="(days_addon[i] != '')">{{days_addon[i]}}</span>
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-else>{{day.lunarDay}}</span>
                              </span>                                
                          </span>                            
                      </div>
                      <div class="calendar-cell cell-rounded positionLocation" :style="'background: '+(day.background)+'; width: '+(cellSize)+'px; height: '+(cellSize)+'px;'" v-else @click="dayClick(day)" :data-day="(day)">
                          <!-- 浮标 -->
                          <span v-if="(day.numMark>0)" class="curriculumNumber">{{day.numMark}}</span>
                          <span v-if="(day.info == 'prev')">
                              <span class="calendar-day" :style="'color: '+(day.color)+';'">{{day.day}}</span>
                              <span v-if="(addon == 'lunar')">
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-if="(lunar)">{{day.lunarDay}}</span>
                              </span>
                              <span v-else-if="(addon == 'custom')">
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'">{{days_addon[i]}}</span>
                              </span>
                              <span v-else-if="(addon == 'mixed')">
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-if="(days_addon[i] != '')">{{days_addon[i]}}</span>
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-else>{{day.lunarDay}}</span>
                              </span>
                          </span>
                          <span v-else-if="(day.info == 'next')">
                              <span class="calendar-day" :style="'color: '+(day.color)+';'">{{day.day}}</span>
                              <span v-if="(addon == 'lunar')">
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-if="(lunar)">{{day.lunarDay}}</span>
                              </span>
                              <span v-else-if="(addon == 'custom')">
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'">{{days_addon[i]}}</span>
                              </span>
                              <span v-else-if="(addon == 'mixed')">
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-if="(days_addon[i] != '')">{{days_addon[i]}}</span>
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-else>{{day.lunarDay}}</span>
                              </span>
                          </span>
                          <span v-else>
                              <span class="calendar-day" :style="'color: '+(day.color)+';'">{{day.day}}</span>
                              <span v-if="(addon == 'lunar')">
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-if="(lunar)">{{day.lunarDay}}</span>
                              </span>
                              <span v-else-if="(addon == 'custom')">
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'">{{days_addon[i]}}</span>
                              </span>
                              <span v-else-if="(addon == 'mixed')">
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-if="(days_addon[i] != '')">{{days_addon[i]}}</span>
                                  <span class="calendar-lunar-day" :style="'color: '+(day.color)+';'" v-else>{{day.lunarDay}}</span>
                              </span>                                
                          </span>                          
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import lunar from './lunar.js';
const minYear = 1900;
const maxYear = 2099;
export default {
  name: 'kw_calendar',
  props: {
    value: {
      type: Object,
      default:function () {
          return {
            
          }
        }
    },
    /**
     * 年份
     */
    initYear: {
      type: Number,
      default: new Date().getFullYear(),
      observer: '_yearChange'
    },

    /**
     * 月份1~12
     */
    initMonth: {
      type: Number,
      default: new Date().getMonth() + 1,
      observer: '_monthChange'
    },

    /**
     * 日期
     */
    day: {
      type: Number,
      default: new Date().getDate(),
      observer: '_dayChange'
    },

    /**
     * 日历范围起点
     */
    startDate: {
      type: String,
      default: '1900-01',
      observer: '_setStartDate'
    },

    /**
     * 日历范围终点
     */
    endDate: {
      type: String,
      default: '2099-12',
      observer: '_setEndDate'
    },

    /**
     * 是否显示标题
     */
    header: {
      type: Boolean,
      default: true,
      observer: '_headerChange'
    },

    /**
     * 是否显示下个月按钮
     */
    next: {
      type: Boolean,
      default: true
    },

    /**
     * 是否显示上个月按钮
     */
    prev: {
      type: Boolean,
      default: true
    },

    /**
     * 显示额外上下月份日期
     */
    showMoreDays: {
      type: Boolean,
      default: false,
      observer: '_moreChange'
    },

    /**
     * 是否显示周标题
     */
    weeks: {
      type: Boolean,
      default: true,
      observer: '_showWeeksChange'
    },

    /**
     * 周标题类型
     */
    weeksType: {
      type: String,
      default: 'en',
      observer: '_weeksTypeChange'
    },

    /**
     * 设置日期字体、背景颜色
     */
    daysColor: {
      type: Array,
      default: function () {[]},
      observer: '_setDaysColor'
    },

    /**
     * 单元格大小
     */
    cellSize: {
      type: Number,
      default: 30,
      observer: '_setCellSize'
    },

    /**
     * 设置日期背景效果
     */
    activeType: {
      type: String,
      default: 'rounded',
      observer: '_setActiveType'
    },

    /**
     * 是否显示农历
     */
    lunar: {
      type: Boolean,
      default: false,
      observer: '_showLunar'
    },

    /**
     * 额外选项
     */
    addon: {
      type: String,
      default: 'none',
      observer: '_setAddon'
    },

    /**
     * 日期附加选项
     */
    daysAddon: {
      type: Array,
      default: function () {[]},
      observer: '_setDaysAddon'
    },
  },
  data() {
    return {
      year:new Date().getFullYear(),
      month:new Date().getMonth+1,
      days_array: [], // 日期数组
      days_color: [], // 日期字体、背景颜色数组
      days_addon: [], // 日期附件
      weekTitle: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      max_year: 2099, // 最大年份
      max_month: 12,  // 最大月份
      min_year: 1900, // 最小年份
      min_month: 1,   // 最小月份
      year_month:""
    };
  },
  created() {
    this.year = this.initYear;
    this.month = this.initMonth;
    const year = this.year;
    const month = this.month;
    var year_month = this.year + "-" + (this.month < 10 ? '0' + this.month : this.month);
    this.year_month = year_month;
    this._weeksTypeChange();
    var days_array = this._setCalendarData(year, month);
    this.days_array = days_array;

  },
  mounted() {
    
  },
  watch:{
    year() {
      this._yearChange();
    },
    month() {
      this._monthChange();
    },
    day() {
      this._dayChange();
    },
    startDate() {
      this._setStartDate();
    },
    endDate() {
      this._setEndDate();
    },
    header() {
      this._headerChange();
    },
    showMoreDays() {
      this._moreChange();
    },
    weeks() {
      this._showWeeksChange();
    },
    weeksType() {
      this._weeksTypeChange();
    },
    daysColor() {
      this._setDaysColor();
    },
    cellSize() {
      this._setCellSize();
    },
    activeType() {
      this._setActiveType();
    },
    lunar() {
      this._showLunar();
    },
    addon() {
      this._setAddon();
    },
    daysAddon() {
      this._setDaysAddon();
    }
  },
  computed:{
  },
  components: {
  },
  methods: {
    setData(json) {
      for(var key in json){
        this[key] = json[key]
      }
    },
    /**
     * 检查年份
     */
    _checkYear: function (year) {
      if (year < minYear) {
        throw new RangeError('年份不能小于' + minYear + '年');
      } else if (year > maxYear) {
        throw new RangeError('年份不能大于' + maxYear + '年');
      }
      return true;
    },

    /**
     * 检查月份
     */
    _checkMonth: function (month) {
      if (month < 1) {
        throw new RangeError('月份不能小于1');
      } else if (month > 12) {
        throw new RangeError('月份不能大于12');
      }
      return true;
    },

    /**
     * 检查日期是否输入正确
     * @param day int 日期
     */
    _checkDay: function (day) {
      if (day < 1) {
        throw new RangeError('日期不能小于1');
      } else if (day > 31) {
        throw new RangeError('日期不能大于31');
      }
      return true;
    },

    /**
     * 年份属性改变
     */
    _yearChange: function () {
      if (this._checkYear(this.year)) {
        this.setData({
          // year:this.initYear,
          days_array: this._setCalendarData(this.year, this.month)
        });
      }
    },

    /**
     * 月份属性改变
     */
    _monthChange: function () {
      if (this._checkMonth(this.month)) {
        this.setData({
          // month: this.initMonth,
          days_array: this._setCalendarData(this.year, this.month)
        });
      }
    },

    /**
     * 日期属性改变
     */
    _dayChange: function () {
      if (this._checkDay(this.day)) {
        
      }
    },

    /**
     * 设置起始日期
     */
    _setStartDate: function (newDate, oldDate) {
      if (newDate.length == 7 && newDate.indexOf('-') == 4) {
        const year = parseInt(newDate.split('-')[0]);
        const month = parseInt(newDate.split('-')[1]);
        if (!isNaN(year) && year >= minYear && !isNaN(month) && month >= 1 && month <= 12) {
          this.setData({
            // startDate: newDate,
            min_year: year,
            min_month: month
          });
        } else {
          throw new Error('起始日期必须是YYYY-MM格式，且大于等于1900-01');
        }
      } else {
        throw new Error('起始日期必须是YYYY-MM格式');
      }
    },

    /**
     * 设置结束日期
     */
    _setEndDate: function (newDate, oldDate) {
      if (newDate.length == 7 && newDate.indexOf('-') == 4) {
        const year = parseInt(newDate.split('-')[0]);
        const month = parseInt(newDate.split('-')[1]);
        if (!isNaN(year) && year <= 2099 && !isNaN(month) && month >= 1 && month <= 12) {
          this.setData({
            // endDate: newDate,
            max_year: year,
            max_month: month
          });
        } else {
          throw new Error('结束日期必须是YYYY-MM格式，且小于等于2099-12');
        }
      } else {
        throw new Error('结束日期必须是YYYY-MM格式');
      }
    },

    /**
     * 是否显示标题
     */
    _headerChange: function (newHeader, oldHeader) {
      // this.setData({
      //   header: !!newHeader
      // });
    },

    /**
     * 是否显示额外的月份日期
     */
    _moreChange: function (newMore, oldMore) {
      this.setData({
        // showMoreDays: !!newMore,
        days_array: this._setCalendarData(this.year, this.month)
      });
    },

    /**
     * 周标题类型
     */
    _weeksTypeChange: function (newVal, oldVal) {
      switch (this.weeksType) {
        case 'en':
          this.setData({
            // weeksType: 'en',
            weekTitle: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
          });
          break;
        case 'cn':
          this.setData({
            // weeksType: 'cn',
            weekTitle: ['日', '一', '二', '三', '四', '五', '六']
          });
          break;
        case 'full-en':
          this.setData({
            // weeksType: 'full-en',
            weekTitle: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
          });
          break;
        default:
          this.setData({
            // weeksType: 'en',
            weekTitle: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
          });
          break;
      }
    },

    /**
     * 是否显示周标题
     */
    _showWeeksChange: function (newVal, oldVal) {
      // this.setData({
      //   weeks: !!newVal,
      // });
    },

    /**
     * 设置单元格宽度
     */
    _setCellSize: function (newSize, oldSize) {
      // this.setData({
      //   cellSize: newSize
      // });
    },

    /**
     * 是否显示农历
     */
    _showLunar: function (newConfig, oldConfig) {
      // this.setData({
      //   lunar: !!newConfig
      // });
    },

    /**
     * 设置日期单元格字体颜色、背景
     */
    _setDaysColor: function (newDaysColor, oldDaysColor) {
      this.setData({
        days_color: this.daysColor
      });
      this.setData({
        days_array: this._setCalendarData(this.year, this.month)
      });
    },

    /**
     * 设置日期背景效果
     */
    _setActiveType: function (newType, oldType) {
      switch (newType) {
        case 'rounded':
        case 'square':
          this.setData({
            activeType: newType
          });
          break;
        default:
          this.setData({
            activeType: 'rounded'
          });
      }
    },

    /**
     * 设置日历
     * @param int year 年份
     * @param int month 月份，取值1~12
     */
    _setCalendarData: function (year, month) {
      const empty_days_count = new Date(year, month - 1, 1).getDay(); // 本月第一天是周几，0是星期日，6是星期六
      let empty_days = new Array;
      const prev_month = month - 1 == 0 ? 12 : month - 1;             // 上个月的月份数
      const prev_year = month - 1 == 0 ? this.year - 1 : this.year;
      /**
       * 上个月的日期
       */
      for (let i = 0; i < empty_days_count; i++) {
        empty_days.push({
          state: 'inactive',
          day: -1,
          month: prev_month,
          year: prev_year,
          info: 'prev',
          color: '#c3c6d1',
          background: 'transparent'
        });
      }

      /**
       * 下个月的日期
       */
      const last_day = new Date(year, month, 0);          // 本月最后一天
      const days_count = last_day.getDate();              // 本月最后一天是几号
      const last_date = last_day.getDay();                // 本月最后一天是星期几
      const next_month = month + 1 == 13 ? 1 : month + 1; // 下个月的月份数
      const next_year = month + 1 == 13 ? this.year + 1 : this.year;
      let empty_days_last = new Array;
      for (let i = 0; i < 6 - last_date; i++) {
        empty_days_last.push({
          state: 'inactive',
          day: -2,
          month: next_month,
          year: next_year,
          info: 'next',
          color: '#c3c6d1',
          background: 'transparent'
        });
      }

      /**
       * 本月的日期
       */
      let temp = new Array;
      for (let i = 1; i <= days_count; i++) {
        temp.push({
          state: 'inactive',
          day: i,
          month: month,
          year: year,
          info: 'current',
          color: '#4a4f74',
          background: 'transparent'
        });
      }
      const days_range = temp;                                   // 本月
      let days = empty_days.concat(days_range, empty_days_last); // 上个月 + 本月 + 下个月            
      // 如果要显示前后月份的日期
      if (this.showMoreDays) {
        // 显示下月的日期
        let index = days.findIndex(element => { return element.day == -2; });
        if (index != -1) {
          const length = days.length;
          const count = length - index;
          for (let i = 1; i <= count; i++) {
            days[index + i - 1].day = i;
          }
        }

        // 显示上月的日期
        index = days.findIndex(element => { return element.day == 1; }) - 1;
        if (index != -1) {
          const last_month_day = new Date(year, month - 1, 0).getDate();
          for (let i = 0; i <= index; i++) {
            days[i].day = last_month_day - index + i;
          }
        }
      }
      /**
       * 设置日期颜色、背景
       */
      for (let i = 0; i < this.days_color.length; i++) {
        const item = this.days_color[i];
        const background = item.background ? item.background : 'transparent';
        for (let j = 0; j < days.length; j++) {
          if (days[j].info == item.month && days[j].day == item.day) {
            if (item.color) {
              days[j].color = item.color + '!important';
            }
            if (item.background) {
              days[j].background = item.background + '!important';
            }
            if (item.numMark > 0) {
              days[j].numMark = item.numMark;
            }
          }
        }
      }

      /**
       * 设置农历
       */
      for (let i = 0; i < days.length; i++) {
        const item = days[i];
        const solarDay = item.day;
        const solarMonth = item.month;
        const solarYear = year;
        if (solarDay > 0) {
          const lunarDate = lunar.solarToLunar(year, solarMonth, solarDay);
          days[i]['lunarMonth'] = lunarDate.monthStr;
          days[i]['lunarDay'] = lunarDate.dayStr;
          if (lunarDate.dayStr == '初一') {
            days[i]['lunarDay'] = lunarDate.monthStr;
          }
        }
      }

      let days_array = new Array;
      let week = new Array;
      for (let i = 0; i < days.length; i++) {
        week.push(days[i]);
        if (i % 7 == 6) {
          days_array.push(week);
          week = new Array;
        }
      }

      if (week.length > 0) {
        days_array.push(week);
      }
      return days_array;
    },

    _setAddon: function (newAddon, oldAddon) {
      if (newAddon == 'none') {
        this.setData({
          lunar: false,
          daysAddon: [],
          addon: 'none'
        });
      } else if (newAddon == 'lunar') {
        this.setData({
          lunar: true,
          daysAddon: [],
          addon: 'lunar'
        });

      } else if (newAddon == 'custom') {
        this.setData({
          addon: 'custom',
          lunar: false,
        });
      } else if (newAddon == 'mixed') {
        this.setData({
          addon: 'mixed',
          lunar: true
        });
      }
    },

    /**
     * 自定义日期数组
     */
    _setDaysAddon: function (newAddon, oldAddon) {
      console.log(newAddon);
      console.log(this.addon);
      if (typeof (newAddon) == 'object' && newAddon instanceof Array) {
        this.setData({
          days_addon: newAddon
        });
      }
    },

    /**
     * 点击下个月
     */
    nextMonth: function () {
      const eventDetail = {
        prevYear: this.year,
        prevMonth: this.month
      };
      var year = this.year;
      var month = this.month;
      if (this.month == 12) {
        year++;
        month = 1;
      } else {
        month++;
      }
      this.setData({
        year:year,
        month:month
      })
      this.setData({
        days_array: this._setCalendarData(this.year, this.month)
      });
      var startDate = this.year + "-" + (this.month < 10 ? '0' + this.month : this.month);
      var endDate = startDate;
      this.value.startDate = startDate;
      this.value.endDate = endDate;
      this.year_month = startDate;

      eventDetail['currentYear'] = this.year;
      eventDetail['currentMonth'] = this.month;
      this.$emit('nextMonth', eventDetail);
    },

    /**
     * 点击上个月
     */
    prevMonth: function () {
      const eventDetail = {
        prevYear: this.year,
        prevMonth: this.month
      };

      if (this.month == 1) {
        this.setData({
          year: this.year - 1,
          month: 12
        });
      } else {
        this.setData({
          month: this.month - 1
        })
      }
      this.setData({
        days_array: this._setCalendarData(this.year, this.month)
      });
      var startDate = this.year + "-" + (this.month < 10 ? '0' + this.month : this.month);
      var endDate = startDate;
      this.value.startDate = startDate;
      this.value.endDate = endDate;
      this.year_month = startDate;

      eventDetail['currentYear'] = this.year;
      eventDetail['currentMonth'] = this.month;
      this.$emit('prevMonth', eventDetail);
    },

    /**
     * 日期选择器变化
     */
    dateChange: function (event) {
      var year = event.split("-")[0];
      var month = event.split("-")[1];
      const eventDetail = {
        prevYear: this.year,
        prevMonth: this.month
      };
      this.setData({
        year: year,
        month: month,
        days_array: this._setCalendarData(year, month)
      });
      var startDate = year + "-" + (month*1 < 10 ? '0' + month*1 : month);
      var endDate = startDate;
      this.value.startDate = startDate;
      this.value.endDate = endDate;
      eventDetail['currentYear'] = year;
      eventDetail['currentMonth'] = month;
      this.$emit('dateChange', eventDetail);
      
    },

    /**
     * 点击具体日期
     */
    dayClick: function (click_day) {
      // const click_day = event.currentTarget.dataset.day;
      const eventDetail = {
        year: click_day.year,
        month: click_day.month,
        day: click_day.day,
        color: click_day.color,
        lunarMonth: click_day.lunarMonth,
        lunarDay: click_day.lunarDay,
        background: click_day.background
      };
      this.$emit('dayClick', eventDetail);
      this.setData({
        days_array: this._setCalendarData(this.year, this.month)
      });
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*
 * 字体
 */


@font-face {font-family: "cwj-icon";
  src: url('//at.alicdn.com/t/font_601455_q8aev4obbmon7b9.eot?t=1522928336476'); /* IE9*/
  src: url('//at.alicdn.com/t/font_601455_q8aev4obbmon7b9.eot?t=1522928336476#iefix') format('embedded-opentype'), /* IE6-IE8 */
  url('data:application/x-font-woff;charset=utf-8;base64,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') format('woff'),
  url('//at.alicdn.com/t/font_601455_q8aev4obbmon7b9.ttf?t=1522928336476') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+*/
  url('//at.alicdn.com/t/font_601455_q8aev4obbmon7b9.svg?t=1522928336476#cwj-icon') format('svg'); /* iOS 4.1- */
}

.cwj-icon {
  font-family:"cwj-icon" !important;
  font-size:16px;
  font-style:normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color:#EF3C00;
}

.cwj-calendar-icon-left:before { content: "\e697"; }

.cwj-calendar-icon-up:before { content: "\e6a5"; }

.cwj-calendar-icon-down:before { content: "\e6a6"; }

.cwj-calendar-icon-right:before { content: "\e6a7"; }

.cwj-calendar-icon-dot:before { content: "\e608"; }


/**
 * 日历组件
 */

.calendar {
    display: block;
    margin: 0rpx 10px;
    font-size: 28rpx;
	cursor: pointer;
}

/**
 * 日历主标题
 */

.calendar-header {
    display: flex;
    align-items: center;
    justify-content: space-around;    
    /* margin: 0rpx 20rpx 20rpx 20rpx; */
    text-align: center;
    font-weight: bold;
	background: #FEEDE4;
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
}

/**
 * 日历周标题
 */

.calendar-weeks {
    display: flex;
    justify-content: space-around;
    font-weight: bold;
	height: 35px;
}

/**
 * 日历周标题单个项目
 */

.calendar-weekday {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40rpx;
    height: 40rpx;
    margin-top: 10rpx;
    margin-bottom: 10rpx;    
    text-align: center;
}

/**
 * 日历日期行
 */

.calendar-row {
    display: flex;
    justify-content: space-around;
	height: 35px;
	margin: 5px 0;
}

/**
 * 日历单个日期项
 */

.calendar-cell {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 10rpx;
    margin-bottom: 10rpx;    
    text-align: center;    
}

.cell-rounded {
    border-radius: 50%;
}

.calendar-lunar-day {    
    font-size: 20rpx;
}

/* 日历浮标 */
.positionLocation{position: relative}
.curriculumNumber{position: absolute;right: -5px;top: -5px;background: #FCD8CC;color: #E86012;width: 16px;height: 16px;border-radius: 16px;text-align: center;line-height: 16px;font-size: 12px}


.calendar-header >>> .el-input__inner {border:none;background:#FEEDE4;color:#EF3C00;font-size:16px;font-weight:bold;}
.calendar-header >>> .el-date-editor.el-input, .el-date-editor.el-input__inner {width:125px}
.calendar-header >>> .el-input__icon {color:#EF3C00;}

.calendar-board {background:#FFFBF0;padding:20px 0;}
</style>
